import styled from 'styled-components';

export const ModalHeader = styled.div`
  background: ${(props) => props.theme.color.bg.secondary};
  svg {
    cursor: pointer;
  }
`;

export const ModalHeaderSection = styled.p`
  color: ${(props) => props.theme.color.text.secondary};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ModalHeaderTitle = styled.h1`
  color: ${(props) => props.theme.color.text.inverse};
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const ModalContent = styled.div`
  padding: 30px;
`;

export const ModalTable = styled.table`
  width: 100%;
  font-family: Montserrat;
  font-style: normal;
  th,
  td {
    height: 60px;
  }
  thead {
    font-size: 14px;
    font-weight: 700;
    line-height: normal;
    color: ${(props) => props.theme.color.text.secondary};
    th {
      &:nth-of-type(2),
      &:nth-of-type(3) {
        text-align: center;
      }
    }
  }
  tbody {
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
    color: #333;
    tr {
      td {
        text-align: center;
        &:nth-of-type(1) {
          text-align: left;
        }
        &:nth-of-type(2),
        &:nth-of-type(3) {
          text-align: center;
        }
      }
    }
  }

  .form-check-input {
    border: 1px solid #999999;
    box-shadow: 0 0 1px #f79422;
    /* background-color: ${(props) => props.theme.color.bg.primary};
    border: 1px solid ${(props) => props.theme.color.ui.primary}; */
    &:checked {
      background-color: ${(props) => props.theme.color.ui.primary};
      border: 1px solid ${(props) => props.theme.color.ui.primary};
    }
  }
`;
